module.exports = __webpack_public_path__ + "static/media/pilates.7862703e.svg";